import * as _m from '@/models';
import { useRef } from 'react';
import { toastSuccess } from '@/lib/toast';
import { Link } from 'react-router-dom';
import ReactTimeAgo from 'react-time-ago';
import { SpriteSvg } from '@/components/common/SpriteSvg';
import { NumberCompactFormat } from '@/components/common/NumberCompactFormat';
import spriteSvg from '@/assets/images/sprite.svg';
import shareSvg from '@/assets/images/share.svg';

type Props = {
  channel_post: _m.ChannelPost;
  from_modal?: boolean; // モーダル表示の場合、親画面のIDと被るためモーダルの場合はIDをランダム化する
};

export const Header = ({ channel_post, from_modal = false }: Props) => {
  const idPrefix = from_modal ? `${Date.now()}_` : '';
  const menuId = `${idPrefix}channel_post_check_${channel_post.id}`;
  const menuOpenerRef = useRef<HTMLInputElement>(null);
  const url = `${process.env.REACT_APP_SITE_URL}/channels/${channel_post.channel_outline.cid}/channel_posts/${channel_post.id}`;

  const onLinkCopyClick = (e: React.MouseEvent) => {
    e.preventDefault();

    navigator.clipboard.writeText(url).then(() => {
      toastSuccess('コピーしました');
    });
    menuOpenerRef.current!.checked = false;
  };

  return (
    <>
      <input type="checkbox" className="opener-checkbox" id={menuId} ref={menuOpenerRef} />
      <div className="post-menu">
        <label className="backdrop" htmlFor={menuId}></label>
        <div className="menus">
          <a
            href={`https://twitter.com/intent/tweet?text=${url}`}
            target="_blank"
            rel="noopenner noreferrer"
            onClick={() => (menuOpenerRef.current!.checked = false)}
          >
            <SpriteSvg name={'icon-x'} className={'i'} />
            投稿する
          </a>
          <Link to="" onClick={(e) => onLinkCopyClick(e)}>
            <SpriteSvg name={'icon-copy'} className={'i'} />
            リンクをコピー
          </Link>
        </div>
      </div>
      <div className="header ch">
        <div className="title">
          <img src={channel_post.channel_outline.icon_url} className="icon" />
          <div className="content">
            {channel_post.title}
            <div className="meta">
              <NumberCompactFormat val={channel_post.movie_plays_count} />
              回視聴・
              <ReactTimeAgo date={new Date(channel_post.posted_at)} locale="ja" />
            </div>
          </div>
        </div>
        <div className="tools">
          <label className="post-menu-opener" htmlFor={menuId}>
            <SpriteSvg name={'icon-share'} className={'i'} />
          </label>
        </div>
      </div>
    </>
  );
};
